import React, { useRef, useState } from "react";
import { Grid, Typography, Box, Backdrop } from "@material-ui/core";
import { useFormik } from "formik";
import moment from "moment";
import CommonButton from "src/components/CommonButton/CommonButton";
import CommonTextFieldDate from "src/components/CommonTextFieldForDate/CommonTextFieldDate";
import { useStyles } from "../style";
import * as Yup from "yup";
import CommonLoader from "src/components/Loader/CommonLoader";

export function RevenueReport() {
  const classes = useStyles();
  const [loader, setLoader] = useState<boolean>(false);
  const startDatePickerRef: any = useRef(null);
  const endDatePickerRef: any = useRef(null);

  const validationSchema = Yup.object().shape({
    startDate: Yup.string().required("This field is required"),
    endDate: Yup.string().required("This field is required"),
  });

  const formik = useFormik({
    initialValues: {
      startDate: moment(new Date().setHours(0, 0, 0, 0)).format("YYYY-MM-DDTHH:mm"),
      endDate: moment().format("YYYY-MM-DDTHH:mm"),
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      setLoader(true);
      const idToken = localStorage.getItem("token");
      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${idToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(values),
      };

      fetch(`${process.env.REACT_APP_API_URL}/get-revenue-by-monthly-report`, requestOptions)
        .then((response) => {
          if (response.status === 200) return response.blob();
          else throw response;
        })
        .then((data) => {
          const newBlob = new Blob([data]);

          // Download code
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(
            new File(
              [newBlob],
              `Monthly-Revenue-Report ${moment().format("DD-MMM-YY, hh:mm A")}.xlsx`
            )
          );
          link.download = `Monthly-Revenue-Report ${moment().format("DD-MMM-YY, hh:mm A")}.xlsx`;
          link.click();
          setLoader(false);
        })
        .catch((error) => {
          setLoader(false);
          throw error;
        });
    },
  });

  return (
    <>
      <Backdrop className={classes.backdrop} open={loader}>
        <CommonLoader />
      </Backdrop>
      <Grid container direction="row" justifyContent="space-between" style={{ paddingTop: "10px" }}>
        <Typography className={classes.pageSubHeading}>Revenue Report</Typography>
        <Grid item xs={12} className={classes.outer} container direction="row">
          <Grid item xs={12} md={5}>
            <Box>
              <CommonTextFieldDate
                label={"Start Date"}
                name={"startDate"}
                cssClassName="customTextField"
                value={formik.values.startDate}
                datePickerRef={startDatePickerRef}
                onChange={(e: any) => {
                  formik.setFieldValue("startDate", moment(e).format("YYYY-MM-DDTHH:mm"));
                  formik.setFieldValue("endDate", "");
                }}
                error={formik.touched.startDate && Boolean(formik.errors.startDate)}
                helperText={formik.touched.startDate && formik.errors.startDate}
                maxDate={moment().format("YYYY-MM-DDTHH:mm")}
                required
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={5}>
            <Box
              sx={{
                marginLeft: { xs: 0, md: "10px" },
                marginTop: { xs: "10px", md: 0 },
              }}
            >
              <CommonTextFieldDate
                label={"End Date"}
                name={"endDate"}
                cssClassName="customTextField"
                value={formik.values.endDate}
                datePickerRef={endDatePickerRef}
                onChange={(e: any) => {
                  formik.setFieldValue("endDate", moment(e).format("YYYY-MM-DDTHH:mm"));
                }}
                error={formik.touched.endDate && Boolean(formik.errors.endDate)}
                helperText={formik.touched.endDate && formik.errors.endDate}
                minDate={formik.values.startDate}
                maxDate={moment().format("YYYY-MM-DDTHH:mm")}
                required
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={2}>
            <Box
              sx={{
                marginLeft: { xs: 0, md: "10px" },
                marginTop: { xs: "10px", md: 0 },
              }}
            >
              <CommonButton
                isGreen
                cssClass={classes.checkButton}
                onClick={() => formik.submitForm()}
              >
                Download Report
              </CommonButton>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
